import "./List.scss"

import React, { FC, useMemo } from "react"
import List, { IListItem, IListProps, ListItemType } from "components/List/List"

const ListKeyValue: FC<React.PropsWithChildren<IListProps>> = ({
    items,
    ...rest
}) => {
    const itemsToDisplay = useMemo<IListItem[]>(() => {
        return items?.filter(item => {
            return typeof item.label !== "undefined"
                || typeof item.value !== "undefined"
        }).map(item => {
            return {
                ...item,
                label: item.labelTestId ? <div data-testid={item.labelTestId}>{item.label}</div> : item.label,
                value: typeof item.value !== "undefined" && item.value !== null && item.value !== ""
                    ? <div className={item.type !== ListItemType.verticalSection && item.type !== ListItemType.vertical ? "text-right font-bold" : ""} data-testid={item.valueTestId}>{item.value}</div>
                    : undefined,
            }
        }) || []
    }, [items])

    if (itemsToDisplay.length === 0) return null

    return (
        <List items={itemsToDisplay} {...rest} />
    )
}

export default ListKeyValue
